import * as React from 'react';
import { update, append, remove, lensProp, over } from 'ramda';

import { getNewPage } from '../../Utils/urvalUtils';
import { IUIUrval, IUIPage } from '../../../../Types/UrvalTypes';
import { ModelContext } from '../../../../Model/ModelContext/ModelContext';

export interface IUrvalProps {
  urval: IUIUrval | null;
  setUrval: (newUrval: IUIUrval) => void;
  children: (urvalActions: IUrvalActions) => React.ReactNode;
  collectionName: string;
}

interface IUrvalActions {
  setPage: (pageIndex: number) => (newPage: IUIPage) => void;
  addNewPage: () => void;
  removePage: (pageNr: number) => void;
}

const pagesLens = lensProp('pages');

class UrvalActions extends React.Component<IUrvalProps> {
  static contextType = ModelContext;
  declare context: React.ContextType<typeof ModelContext>;

  setPage = (pageIndex: number) => (newPage: IUIPage) => {
    if (this.props.urval) {
      this.props.setUrval(
        over(pagesLens, update(pageIndex, newPage), this.props.urval)
      );
    }
  };

  addNewPage = () => {
    if (this.props.urval) {
      const newUrval = over(
        pagesLens,
        append(
          getNewPage(this.context.avenyCollectionMap, this.props.collectionName)
        ),
        this.props.urval
      );
      this.props.setUrval(newUrval);
    }
  };

  removePage = (pageNr: number) => {
    if (this.props.urval) {
      this.props.setUrval(
        over(pagesLens, remove(pageNr - 1, 1), this.props.urval)
      );
    }
  };

  render() {
    return this.props.children({
      setPage: this.setPage,
      addNewPage: this.addNewPage,
      removePage: this.removePage,
    });
  }
}

export default UrvalActions;
